var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoInstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -25 65 110",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.1)",
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.781 50.1854V46.214C60.781 44.942 59.7261 43.8871 58.454 43.8871H54.1724V18.1971H60.781L35.091 0.418858C34.2843 -0.139619 33.2294 -0.139619 32.4538 0.418858L6.73276 18.1971H13.3414V43.856H9.05975C7.78766 43.856 6.73276 44.9109 6.73276 46.183V50.1544H2.32699C1.0549 50.1544 0 51.2093 0 52.4814V54.343C0 55.6151 1.0549 56.67 2.32699 56.67H65.1868C66.4589 56.67 67.5138 55.6151 67.5138 54.343V52.4814C67.5138 51.2093 66.4589 50.1544 65.1868 50.1544H60.781V50.1854ZM47.6568 43.856H42.7236V18.1971H47.6568V43.856ZM36.208 18.1971V43.856H31.2748V18.1971H36.208ZM19.857 18.1971H24.7902V43.856H19.857V18.1971Z",
    className: "symbol"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInstitution);
export default __webpack_public_path__ + "static/media/ico-institution.b37bd3cbf7784304a7b4e4b982f25e7f.svg";
export { ForwardRef as ReactComponent };